import React, { use, useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import './ChangeUserSettingForm.scss';

const ChangeUserSettingForm = ({ title, label, initialValue = '', usePlaceholder = true, onConfirm, onClose }) => {
  // Initialize the newValue with the current (initial) value.
  const [newValue, setNewValue] = useState(usePlaceholder ? initialValue : '');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = e => {
    setNewValue(e.target.value);
  };
  
  const handleSubmit = async (e) => {
    console.log(`handleSubmit: ${e.target.value}`);
    e.preventDefault(); // Prevent default form submission behavior
    setIsLoading(true);
    try {
      // Only attempt to update if the new value is different from the initial value.
      await onConfirm(newValue);
      toast.success(`${title} updated successfully.`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } catch (error) {
      toast.error(`Failed to update ${title}: ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Disable the submit button if the new value is empty or hasn't changed.
  const isSubmitDisabled = () => {
    return newValue.trim() === '' || newValue === initialValue;
  };

  return (
    <Form className="update-setting-form-container" onSubmit={handleSubmit}>
      <div className="form-header text-center">
        <img src={imgCamelLogo} alt="Logo" />
      </div>
      <div className="p-2">
        <h3>{title}</h3>

        {/* Display the current value as a read-only field */}
        <Form.Group controlId="currentValue">
          <Form.Label className="small">Current {label}</Form.Label>
          <Form.Control type="text" readOnly value={initialValue} size="lg" />
        </Form.Group>

        {/* Input for the new value */}
        <Form.Group controlId="newValue">
          <Form.Label className="small">New {label}</Form.Label>
          <Form.Control
            type="text"
            autoFocus
            placeholder={`Enter new ${label}`}
            value={newValue}
            onChange={handleChange}
            size="lg"
          />
        </Form.Group>

        {/* Updated actions container to right-align the buttons */}
        <div className="d-flex justify-content-end">
          <Button variant="outline-danger" className="mr-2" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="outline-danger" type="submit" size="sm" disabled={isSubmitDisabled()}>
            {isLoading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="mr-1"
              />
            )}
            Save
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default ChangeUserSettingForm;